export default "__VITE_ASSET__DIsGtKnr__"